module.exports = __webpack_public_path__ + "static/FOTO_3-f68c9069569e4c8a65f9eb413d7b54a7.png";